import React, { useEffect, useState } from 'react'
import { Field, Form, IconClose, Modal, PlainTextInput, LabeledField, Button, InputSelect, Select } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import useCreateTag from '../Model/Create'
import { isEmpty } from 'lodash'
import Switch from '../../../Users/Components/Switch'
import { getTagTypeLabel } from '../../Utils/tagTypeLabel'
import { tagsTypeArray } from '../../../../utils/getTagsType'
import TagBadgeComponent from '../../../Student/modal/InfoStudent/TagsBadge/Components/tagBadgeComponent'
const NewTagModal = (props) => {
    const { tagToEdit, isOpen, setIsOpen, refetchList } = props
    const DEFAULT_BACKGROUND_COLOR = '#F2F2FE'
    const DEFAULT_TEXT_COLOR = '#696CFF'
    const { translate } = useTranslation()
    const toggle = setIsOpen
    const [form, setForm] = useState({})
    const [errors, setError] = useState({})
    // const tagsTypeArray = ['zinkerzCamp']
    const { submit, loading: loadingAdd, validationErrors } = useCreateTag((result) => {
        refetchList()
        toggle()
    }, console.log)
    useEffect(() => {
        if (!tagToEdit) {
            setForm({
                name: '',
                type: null,
                isActive: true,
                backgroundColor: DEFAULT_BACKGROUND_COLOR,
                textColor: DEFAULT_TEXT_COLOR
            })
            return
        }

        setForm({
            id: tagToEdit?.id,
            name: tagToEdit?.name,
            type: tagToEdit?.type,
            isActive: tagToEdit?.isActive,
            backgroundColor: tagToEdit?.backgroundColor || DEFAULT_BACKGROUND_COLOR,
            textColor: tagToEdit?.textColor || DEFAULT_TEXT_COLOR
        })
    }, [tagToEdit])

    useEffect(() => {
        if (isEmpty(validationErrors)) return
        var customErrors = {}
        Object.keys(validationErrors).forEach(key => {
            const keyVal = key.split('.')[1]
            customErrors[keyVal] = translate('tags.errors.' + keyVal)
        })
        setError(customErrors)
        // eslint-disable-next-line
    }, [validationErrors])

    const changeStatusTag = () => {
        setForm({
            ...form,
            isActive: !form.isActive
        })
    }

    return (
        <Modal
            className='modal-sidebar modal-colored white-modal modal-desktop-half pl-3'
            isOpen={isOpen}
            toggle={() => { toggle() }}
            backdrop='static'
            Head={
                <div className='modal-header p-0 m-0'>
                    <div className='d-flex justify-content-between w-100 p-7'>
                        <h2 className='font-weight-bold'>{translate('tags.addNewTag.title')}
                        </h2>
                        <IconClose onClick={() => { toggle() }} className='text-gray' />
                    </div>
                </div>
            }
        >
            <Form value={form} onChange={setForm} validationErrors={errors}>
                <div className='d-flex flex-column pr-6 pl-7'>
                    {tagToEdit && <div className='row d-flex m-0 mt-3'>
                        <div className='col-12 p-0 pr-1'>
                            <label className='text-gray font-weight-light mb-2'>{translate('tags.addNewTag.isActive')}</label>
                            <Switch idComponent={'toggle-isActive'} isOn={form?.isActive} onColor='#696CFF' handleToggle={() => changeStatusTag()} />
                        </div>
                    </div>}
                    <div className='row d-flex m-0 mt-3'>
                        <div className='col-12 p-0 pr-1'>
                            <label className='text-gray font-weight-light mb-2'>{translate('tags.addNewTag.name')}</label>
                            <Field
                                component={PlainTextInput}
                                type={LabeledField}
                                fieldName='name'
                                fieldType='text'
                            />
                        </div>
                    </div>
                    <div className='row d-flex m-0'>
                        <div className='col-12 p-0 pr-1'>
                            <label className='text-gray font-weight-light mb-2'>{translate('tags.addNewTag.type')}</label>
                            <Field
                                // component={PlainTextInput}
                                type={InputSelect}
                                component={Select}
                                fieldName='type'
                                isClearable={false}
                                placeholder='Type'
                                fieldType='text'
                                options={tagsTypeArray.map((type) => ({ value: type, label: getTagTypeLabel(type) }))}
                                value={form?.type}
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        type: e
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className='row d-flex m-0 mt-3'>
                        <div className='col-6 p-0 pr-2'>
                            <label className='text-gray font-weight-light mb-2'>{translate('tags.addNewTag.backgroundColor')}</label>
                            <Field
                                component={PlainTextInput}
                                type={LabeledField}
                                fieldName='backgroundColor'
                                fieldType='color'
                                className='col-3'
                            />
                        </div>
                        <div className='col-6 p-0 pl-2'>
                            <label className='text-gray font-weight-light mb-2'>{translate('tags.addNewTag.textColor')}</label>
                            <Field
                                component={PlainTextInput}
                                type={LabeledField}
                                fieldName='textColor'
                                fieldType='color'
                                className='col-3'
                            />
                        </div>
                    </div>
                    <div className='mx-n2'>
                        <TagBadgeComponent tag={form} />

                    </div>
                    {/* <Badge
                        className="badge badge-pill d-flex flex-row align-items-center py-1 mx-2"
                        style={{
                            backgroundColor: form.backgroundColor || '#000000',
                            border: 'none',
                            outline: 'none',
                            boxShadow: 'none'
                        }}
                    >
                        <span style={{ color: form.textColor || '#000000' }}>
                            {form.name || 'Example Tag'}
                        </span>
                    </Badge> */}
                    <div className='px-3 px-lg-5 px-xl-7 d-flex flex-column my-5'>
                        <div className='m-0 p-0 row'>
                            <Button
                                color='secondary'
                                activity={loadingAdd}
                                className='col-12'
                                label='Save'
                                onClick={() => { submit({ input: form }) }}
                                style={{ borderRadius: `${'16px 16px 16px 16px'}` }}
                            />
                        </div>
                    </div>
                </div>
            </Form>
        </Modal>
    )
}

export default NewTagModal